import { AuthCanActivateGuard } from '../auth/_guards/auth.can-activate.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanDeactivateGuard } from '@app/auth/_guards/auth.can-deactivate-guard.service';
import { DailysyncdashboardDetailComponent } from './dailysyncdashboard-detail/dailysyncdashboard-detail.component';

let routes: Routes = [
	{
		path: '',
		redirectTo: 'dailysyncdashboard-detail',
		pathMatch: 'full'
	},
	{
		path: 'dailysyncdashboard-detail',
		component: DailysyncdashboardDetailComponent,
		canActivate: [ AuthCanActivateGuard ],
		canDeactivate: [ CanDeactivateGuard ],
		data: {
			label: "DAILY_SYNC_DASHBOARD",
			expectedRoles: [8,1],
			breadcrumb: "DAILY_SYNC_DASHBOARD",
		}
	}
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class DailySyncDashboardRoutingModule
 {

}
